const {SearchActions} = require('./SearchActions');
const {SearchBar} = require('./SearchBar');

require('./search-bar.less');

module.exports = {SearchActions, SearchBar}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/SearchBar/index.es6
 **/